var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconPencil = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.809,
    height: 12.831,
    viewBox: "0 0 12.809 12.831",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pencil",
    d: "M12.809,2A2.006,2.006,0,0,0,9.384.587L1.309,8.695a2.4,2.4,0,0,0-.58.94l-.008.023L0,12.831l3.182-.712.024-.008a2.407,2.407,0,0,0,.941-.58l8.076-8.108A1.993,1.993,0,0,0,12.809,2ZM1.765,11.409l-.337-.338L1.671,10l1.168,1.169Zm9.749-8.695-7.84,7.872L2.254,9.166,7.624,3.774l.818.818.708-.708-.819-.819L9.093,2.3l.821.821.708-.708L9.8,1.589l.293-.295a1,1,0,1,1,1.421,1.42Zm-6.244,9.1h7.54v1H4.271Zm0,0",
    transform: "translate(0 0.001)",
    fill: "#f1c400"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPencil, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-pencil.ece9e966.svg";
export { ForwardRef as ReactComponent };